
export default {
	methods: {},
	methodIds: [],
}